import { Link } from 'react-router-dom';

// --- INLINE SVG ICONS ---
// Harici bağımlılık olmadan çalışan sosyal medya ikonları
const SocialIcons = {
  Github: ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
    </svg>
  ),
  Twitter: ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
    </svg>
  ),
  Linkedin: ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
    </svg>
  )
};

export const Footer = () => {
  return (
    <footer className="bg-[#0F1C2E] text-white relative overflow-hidden font-sans border-t border-white/5">
      {/* Background Decorations */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500"></div>
      <div className="absolute -top-20 -right-20 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-orange-500/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">

          {/* 1. Marka Alanı */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              {/* Logo Mockup */}
              <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-red-500 rounded-xl flex items-center justify-center shadow-lg transform rotate-3">
                <span className="text-white font-black text-xl font-sans">M</span>
              </div>
              <h3 className="text-2xl font-black tracking-tight">Mucittin</h3>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm font-medium">
              Çocuklar için modern, güvenli ve eğlenceli öğrenme platformu.
              Hayal et, tasarla ve geleceği inşa et! 🚀
            </p>
          </div>

          {/* 2. Hızlı Linkler */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-orange-400 tracking-wide">Keşfet</h4>
            <ul className="space-y-3">
              {[
                { label: 'Ana Sayfa', path: '/' },
                { label: 'Hakkımızda', path: '/about' },
                { label: 'Oyunlar & Aktiviteler', path: '/services' },
                { label: 'Blog', path: '/blog' }
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-gray-400 hover:text-white hover:translate-x-1 transition-all inline-block text-sm font-medium">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 3. Destek */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-purple-400 tracking-wide">Destek</h4>
            <ul className="space-y-3">
              {[
                { label: 'İletişim', path: '/contact' },
                { label: 'Sıkça Sorulanlar', path: '/faq' },
                { label: 'Gizlilik Politikası', path: '/privacy' },
                { label: 'Ebeveyn Rehberi', path: '/parents' }
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-gray-400 hover:text-white hover:translate-x-1 transition-all inline-block text-sm font-medium">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 4. Sosyal & Bülten */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-pink-400 tracking-wide">Topluluk</h4>
            <div className="flex gap-4 mb-6">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-white/20 rounded-full flex items-center justify-center transition-all hover:scale-110 group border border-white/5">
                <SocialIcons.Github className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-blue-400/20 rounded-full flex items-center justify-center transition-all hover:scale-110 group border border-white/5">
                <SocialIcons.Twitter className="w-5 h-5 text-gray-400 group-hover:text-blue-400 transition-colors" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/5 hover:bg-blue-600/20 rounded-full flex items-center justify-center transition-all hover:scale-110 group border border-white/5">
                <SocialIcons.Linkedin className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors" />
              </a>
            </div>

            {/* Mini Newsletter */}
            <div className="bg-white/5 rounded-xl p-4 border border-white/10">
              <p className="text-xs text-gray-400 mb-3 font-bold uppercase tracking-wider">Haber bülteni</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="E-posta adresi"
                  className="bg-black/20 w-full rounded-lg px-3 py-2 text-sm text-white placeholder:text-gray-600 outline-none focus:ring-1 focus:ring-orange-400 transition-all"
                />
                <button className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-400 hover:to-pink-400 text-white rounded-lg px-3 py-2 font-bold transition-all shadow-lg shadow-orange-500/20">
                  Go
                </button>
              </div>
            </div>
          </div>

        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-16 pt-8 text-center">
          <p className="text-gray-500 text-sm font-medium">
            © {new Date().getFullYear()} Mucittin Inc. Tüm hakları saklıdır. <span className="text-red-500 animate-pulse">♥</span> ile tasarlandı.
          </p>
        </div>
      </div>
    </footer>
  );
};